import React from "react";
import { Link } from "react-router-dom";

import srvimg1 from "../../images/icon/clipboard.svg";
import srvimg2 from "../../images/icon/briefcase.svg";
import srvimg3 from "../../images/icon/chart.svg";
import srvimg4 from "../../images/icon/badge.svg";
import srvimg5 from "../../images/icon/goal.svg";
import srvimg6 from "../../images/icon/handshake.svg";

const Services = (props) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  const service = [
    {
      sIcon: srvimg1,
      title: "Recrutamento e Seleção",
      des: "Processos de recrutamento ágeis e assertivos para encontrar os profissionais ideais para sua empresa.",
      link: "/service-single",
    },
    {
      sIcon: srvimg5,
      title: "Consultoria Estratégica",
      des: "Oferecemos consultoria personalizada para otimizar suas práticas de RH e alinhar sua equipe com os objetivos da empresa.",
      link: "/service-single",
    },
    {
      sIcon: srvimg4,
      title: "Treinamento e Desenvolvimento",
      des: "Investimos no crescimento contínuo dos seus colaboradores com programas de capacitação que aumentam a performance.",
      link: "/service-single",
    },
    {
      sIcon: srvimg6,
      title: "Hunting",
      des: "Atuamos em diversos segmentos do mercado,buscando os melhores profissionais com agilidade e precisão.",
      link: "/service-single",
    },
    {
      sIcon: srvimg2,
      title: "Planejamento de Carreira",
      des: "Ajudamos seus talentos a planejar o crescimento dentro da empresa, promovendo o engajamento e a retenção.",
      link: "/service-single",
    },
    {
      sIcon: srvimg3,
      title: "Assessment de Potencial e Talentos",
      des: "O mapeamento das competências, habilidades e valores individuais possibilita a inserção estratégica do profissional.",
      link: "/service-single",
    },
  ];

  return (
    <section
      className="wpo-service-section section-padding-one"
      style={{ background: "#f4f8fc" }}
    >
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="wpo-section-title">
              <h2>Benefícios</h2>
            </div>
          </div>
        </div>
        <div className="row">
          {service.map((service, sitem) => (
            <div className="col-lg-4 col-md-6 col-12" key={sitem}>
              <div className="wpo-service-item">
                <div className="wpo-service-icon">
                  <div className="icon">
                    <img src={service.sIcon} alt="" />
                  </div>
                </div>
                <div className="wpo-service-text">
                  <h2>
                    <Link onClick={ClickHandler} to={service.link}>
                      {service.title}
                    </Link>
                  </h2>
                  <h3 className="fs-4 fw-light">{service.des}</h3>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
